module.exports = __webpack_public_path__ + "img/97.314d543d.png";